import http from "./apiClient";

export const getNoctisReachability = async () => {
  const res = await http.get("/noctis/reachability");
  return res?.data;
};

